import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const getSearchPollUser = (SearchText) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.SOCIAL.SEARCH_POLL_USER(SearchText)
  );
};

export default getSearchPollUser;
